import Swiper from "swiper";
import { A11y, Keyboard, Navigation, Pagination } from "swiper/modules";
import { SwiperOptions } from "swiper/types";

export class Carousel {
  private element: HTMLElement;

  constructor(element: HTMLElement) {
    if (!!element) {
      this.element = element;
      this.init();
    }
  }

  private init() {
    const swiperParams: SwiperOptions = {
      slidesPerView: 1,
      autoHeight: true,
      spaceBetween: 50,
      loop: true,
      modules: [Navigation, Pagination, A11y, Keyboard],
      a11y: {
        enabled: true,
        nextSlideMessage: "Next",
        prevSlideMessage: "Previous",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: false,
        renderBullet: function (index, className) {
          return `<button class="${className}"><span class="visible-for-screen-readers">Navigate to Slide ${
            index + 1
          }</span></button>`;
        },
      },
      keyboard: {
        enabled: true,
      },
      navigation: {
        nextEl: ".swiper__prev-next--next",
        prevEl: ".swiper__prev-next--prev",
      },
    };

    const swiper = new Swiper(this.element, swiperParams);

    const bullets = this.element.querySelectorAll(
      ".swiper-pagination-bullet"
    ) as NodeListOf<HTMLButtonElement>;
    bullets.forEach((bullet, index) => {
      bullet.addEventListener("click", () => {
        swiper.slideToLoop(index);
      });
    });
  }
}

export default function carouselInit() {
  const carousel = document.querySelectorAll(
    ".carousel"
  ) as NodeListOf<HTMLElement>;
  for (let i = 0; i < carousel.length; i++) {
    new Carousel(carousel[i]);
  }
}
